// import hooks useSelector and useDispatch from react-redux
import {useSelector, useDispatch} from 'react-redux';

// import a refence to our UsersStoreSlice
import {UsersStoreSlice} from './users.slice';
// import a reference to our RootStateInterface
import {RootStateInterface} from '../root';
// import references to our itesms tore and actions interfaces
import {UsersStoreInterface, UsersStoreActionsInterface} from './models';
// import a reference to our ItemInterface
//import {JobInterface} from '../../models/jobs/Job.interface';

// import a reference to our apiClient instance
import {apiClient} from '../../api-client';

// hook to allows us to consume the ItemsStore instance in our components
export function useUsersStore(): UsersStoreInterface {
  // note: we are callin dispatch "commit" here, as it make more sense to call it this way
  // feel free to just call it dispatch if you prefer
  const commit = useDispatch();

  // get a reference to our slice actions (which are really our mutations/commits)
  const mutations = UsersStoreSlice.actions;

  // our items store actions implementation:
  const actions: UsersStoreActionsInterface = {
    logoutUser: async () => {
      commit(mutations.setLoading(true));

      // invoke our API cient fetchItems to load the data from an API end-point
      const data = await apiClient.users.logoutUser();
      if (typeof data === 'string') {
        commit(mutations.setError(data));
        commit(mutations.setLoading(false));
      } else {
        //const values: any = Object.values(data);
        //commit(mutations.setUsers(values[0]));
        //commit(mutations.setLoading(false));
      }
    },
    loginUser: async formData => {
      commit(mutations.setLoading(true));

      // invoke our API cient fetchItems to load the data from an API end-point
      const data: any = await apiClient.users.loginUser(formData);
      if (typeof data === 'string') {
        commit(mutations.setError(data));
        commit(mutations.setLoading(false));
      } else {
        commit(mutations.setLoading(false));
        const values: any = Object.values(data);
        commit(mutations.setUser(values[0]));
      }
    },
  };

  // return our store intance implementation
  return {
    getters: {
      loading: useSelector((s: RootStateInterface) => s.users.loading),
      user: useSelector((s: RootStateInterface) => s.users.user),
      error: useSelector((s: RootStateInterface) => s.users.error),
    },
    actions: actions,
  };
}
